import request from 'utils/request'

/**
 * 下载审批列表
 * @param {*} data
 */
export const getApplyList = data => request().post('bp/apply/page', data)

/**
 * 全部查询审批列表
 * @param {*} data
 */
export const getAutoList = data => request().post('bp/apply/page/auto', data)

/**
 * 下载审批列表
 * @param {*} data
 */
export const downloadApplyTable = data =>
  request().post('bp/apply/export', data, { responseType: 'arraybuffer' })

/**
 * 获取CRM申请列表
 * @param {*} data
 */
export const getCrmApplyList = data => request().post('bp/apply/crm/page', data)

/**
 * 下载CRM申请列表
 * @param {*} data
 */
export const downloadCrmTable = data =>
  request().post('bp/apply/crm/export', data, { responseType: 'arraybuffer' })

export const getBatchList = data => request().post('bp/batch/apply/page', data)

export const exportAuditRecord = data =>
  request().post('bp/batch/apply/export', data, {
    responseType: 'arraybuffer',
  })

export const getCreditManagers = () => request().get('bp/apply/listCManager')
